import React from 'react'
import ModeFullScreen from './modeFullScreen'

const ModeOrga = () => <ModeFullScreen />

export default ModeOrga
